import * as _ from 'lodash';
import PS from "./ProjectScopeActionsNew";
import {newFeatureGroupActionTypes} from './NewFeatureGroup/NewFeatureGroupActions';
import {NEW_SCOPE_SET_CATEGORIES_VISUALIZER} from "../../constants/actionTypes";

const initialState = {
  featuresGroups: [],
  featuresGroupsAll: [], // is used to keep all aray and then filter it on search
  hasKitchen: false,
  hasBathroom: false,
  term: '',
  mode: 'All',
  loading: false,
  pendingChanges: [],
  featuresGroupsRequestCount: 0
};

export default function (state = initialState, action) {
  switch (action.type) {
    case PS.ActionTypes.resetAll:
      return {...state, featuresGroups: []};
    case PS.ActionTypes.loadFeaturesGroupsStart:
      return {...state, featuresGroups: [], term: "", loading: true, featuresGroupsRequestCount: ++state.featuresGroupsRequestCount};
    case PS.ActionTypes.loadFeaturesGroupsEnd:
      const {groups, hasKitchen, hasBathroom} = action.payload;
      return {...state, loading: false, term: "", featuresGroups: groups, featuresGroupsAll: [...groups], hasBathroom, hasKitchen};
    case PS.ActionTypes.unloadFeaturesGroups:
      return {...initialState};
    case NEW_SCOPE_SET_CATEGORIES_VISUALIZER:
      return {...state, term: ""};
    case PS.ActionTypes.setSearchTerm:
      return Object.assign({}, state, {...action.payload});
    case PS.ActionTypes.setMode:
      return {...state, mode: action.payload.mode};
    case PS.ActionTypes.updateFeatureGroup:
      let newState = {...state, pendingChanges: [...state.pendingChanges]};
      let idx = _.findIndex(newState.pendingChanges, fg => fg.groupName == action.payload.featureGroup.groupName);
      if(idx >= 0) {
        let oidx = _.findIndex(newState.featuresGroups, fg => fg.groupName == action.payload.featureGroup.groupName);
        if(oidx >= 0 && _.isEqual(newState.featuresGroups[oidx], action.payload.featureGroup)) {
          newState.pendingChanges.splice(idx, 1);
        } else {
          newState.pendingChanges[idx] = {...action.payload.featureGroup};
        }
      } else {
        newState.pendingChanges.push({...action.payload.featureGroup});
      }
      return newState;
    case PS.ActionTypes.mergePendingChanges:
      newState = {...state};
      for(let idx in newState.pendingChanges) {
        let pc = newState.pendingChanges[idx];
        let eidx = _.findIndex(newState.featuresGroups, fg => fg.groupName == pc.groupName);
        if(eidx >= 0) {
          newState.featuresGroups[eidx] = {...pc};
        } else {
          newState.featuresGroups.push({...pc});
        }
      }
      newState.pendingChanges = [];
      return newState;
    case PS.ActionTypes.cancelPendingChanges:
      return {...state, pendingChanges: []};
    case newFeatureGroupActionTypes.ADD:
      let newFG = {
        groupName: action.payload.name,
        description: action.payload.description,
        customImageUrl: action.payload.image,
        enabled: false,
        visible: false,
        customDisplayName: ''
      };
      let featuresGroups = [...state.featuresGroups];
      featuresGroups.unshift(newFG);
      return {...state, featuresGroups };
    case PS.ActionTypes.updateFeatureGroups:
      return {...state, ...action.payload};
  }

  return state;
}
